import { createContext, useContext, useMemo, useState } from "react";

const SelectedShoppingCartStageValueContext = createContext();
const SelectedShoppingCartStageActionsContext = createContext();

export function SelectedShoppingCartStageContextProvider({ children }) {
    const [selectedShoppingCartStage, setSelectedShoppingCartStage] = useState(null);

    const selectedShoppingCartStageActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setSelectedShoppingCartStage(newValues);
                },
                setValue: setSelectedShoppingCartStage
            }
        },
        []
    )

    return (
        <>
            <SelectedShoppingCartStageActionsContext.Provider value={{ selectedShoppingCartStage: selectedShoppingCartStageActions }}>
                <SelectedShoppingCartStageValueContext.Provider value={{ selectedShoppingCartStage }}>
                    {children}
                </SelectedShoppingCartStageValueContext.Provider>
            </SelectedShoppingCartStageActionsContext.Provider>
        </>
    );
}

export function useSelectedShoppingCartStageValueContextHook(props) {
    const value = useContext(SelectedShoppingCartStageValueContext);

    if (value === undefined) {
        throw new Error('useSelectedShoppingCartStageValueContextHook should be used within SelectedShoppingCartStageContextProvider');
    }

    return {
        selectedShoppingCartStage: value.selectedShoppingCartStage,
    };
}

export function useSelectedShoppingCartStageActionsContextHook(props) {
    const value = useContext(SelectedShoppingCartStageActionsContext);

    if (value === undefined) {
        throw new Error('useSelectedShoppingCartStageActionsContextHook should be used within SelectedShoppingCartStageContextProvider');
    }

    return {
        selectedShoppingCartStage: {
            onSet: value.selectedShoppingCartStage.onSet,
            setValue: value.selectedShoppingCartStage.setValue
        },
    };
}